module.exports = __webpack_public_path__ + "img/add_ticket.abc4bd5a.svg";